(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;
  var targetSel = bar.getAttribute('data-target-selector') || '.product-form__buttons';
  var target = document.querySelector(targetSel);
  var btn = bar.querySelector('[data-sticky-atc-button]');
  if (!btn) return;

  function findForm() {
    if (target) {
      var f = target.closest('form[action*="/cart/add"]');
      if (f) return f;
    }
    return document.querySelector('form[action*="/cart/add"]');
  }

  function show() {
    bar.removeAttribute('hidden');
    bar.classList.add('is-visible');
  }
  function hide() {
    bar.classList.remove('is-visible');
  }

  if (target && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) hide();
        else show();
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
    io.observe(target);
  } else {
    show();
  }

  btn.addEventListener('click', function () {
    /* Fire GA4 event FIRST, before submit call (per Perplexity R1). */
    if (typeof gtag === 'function') {
      gtag('event', 'sticky_atc_click', {
        product_id: btn.getAttribute('data-product-id'),
        product_handle: btn.getAttribute('data-product-handle'),
        page_location: window.location.href
      });
    }
    btn.setAttribute('disabled', 'disabled');
    function reEnable(){ setTimeout(function(){ btn.removeAttribute('disabled'); }, 1500); }

    /* Preferred: click the real submit button inside <product-form>. The theme's
       ProductForm custom element listens for 'submit', so a synthetic click on
       the real submit button triggers its AJAX cart-drawer flow.
       Works in every browser (no requestSubmit needed, no Safari <16 issue)
       because button.click() always fires a synthetic submit. */
    var pfBtn = document.querySelector('product-form [type="submit"]:not([disabled]):not([aria-disabled="true"])');
    if (pfBtn) {
      pfBtn.click();
      reEnable();
      return;
    }

    /* Fallback: no <product-form> element (some pages may render the form
       outside the custom element). Submit the form directly. */
    var form = findForm();
    if (!form) { reEnable(); return; }
    if (typeof form.requestSubmit === 'function') {
      var realBtn = form.querySelector('[type="submit"], .product-form__submit');
      if (realBtn) form.requestSubmit(realBtn);
      else form.requestSubmit();
    } else {
      /* Safari <16 + no <product-form>: dispatch a synthetic submit event so
         any listener catches it. form.submit() would skip listeners. */
      var evt;
      try { evt = new Event('submit', { cancelable: true, bubbles: true }); }
      catch(e){ evt = document.createEvent('Event'); evt.initEvent('submit', true, true); }
      var handled = !form.dispatchEvent(evt);
      if (!handled) form.submit();
    }
    reEnable();
  });
})();
